import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaEyeSlash, FaEye } from "react-icons/fa";

import logo from "../../images/penspace.svg";
import styles from './AdminLogin.module.scss';


function LoginForm() {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState('');

    const [loginErrorMessage, setLoginErrorMessage] = useState('');

    useEffect(() => {
        const adminData = localStorage.getItem("user");
        if (adminData) {
            navigate('/admin');
        }
    }, [navigate]);

    const handleLogin = async () => {
        if (email.trim() !== "" && password.trim() !== "") {
            setLoginErrorMessage("");

            try {
                const response = await axios.post(`${process.env.REACT_APP_API_ROOT}/api/admin/login`, { email, password });

                if (response.data.status) {
                    localStorage.setItem('user', JSON.stringify(response.data.data));
                    // Tell PermissionProvider to re-read: it mounted before
                    // login, and `storage` events don't fire in the tab that
                    // wrote them. Without this the sidebar stays empty until a
                    // manual page refresh.
                    window.dispatchEvent(new Event('penspace:auth'));
                    navigate('/admin')
                } else {
                    console.error("password is wrong")
                }
            } catch (error) {
                const errorMessage = error.response?.data?.error || error.response?.data?.message || "Login failed. Please try again.";
                setLoginErrorMessage(errorMessage);
                console.error("Error fetching login data:", error);
            }
        } else {
            if (email === "") {
                setLoginErrorMessage("please enter email")
            } else {
                setLoginErrorMessage("please enter password")
            }
        }
    };


    return (
        <div className={styles.wrapper}>
            <form className={styles.card}>
                <div>
                    <div className="d-flex justify-content-center">
                        <img className={styles.logo} src={logo} alt='' />
                    </div>
                    <h3>Admin Login</h3>
                </div>
                {loginErrorMessage !== "" && <p className={styles.validationMessage}>{loginErrorMessage}</p>}

                <div className="mb-3">
                    <p>Username</p>
                    <input
                        type="text"
                        name="email"
                        placeholder="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div>
                    <p>Password</p>
                    <div className={styles.passwordIcon}>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            placeholder="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <i onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? <FaEye size={22}/> : <FaEyeSlash size={22}/>}
                        </i>
                    </div>
                </div>
                <div className="d-flex justify-content-center bt-lg w-full">
                    <button type="button" className="btn btn-dark" onClick={handleLogin}>Login</button>
                </div>
            </form>
        </div>
    )
}

export default LoginForm
